
import { Accordion, AccordionDetails, AccordionSummary, Divider, Typography, Grid } from "@mui/material";
import { useState } from "react"; // Added useCallback
import { CheckGreen, DownIcon, InfoIcon } from "../../../../../assets/common-svg/CommonSvg";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCycle } from "../../../../../bmr/slices/common";
import CryoLsmFormDialog from "./CryoLsmFormDialog";
import { selectDynamicBags } from "../../../../../bmr/slices/manufacturer";
import ReprintComponent from "../../../../../bmr/pages/Manufacturer/RePrintComponent"

import BsModal from "../../../common/BaseModal";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../common/FormikControl";
import { updateMonocyte } from "../../../../../bmr/slices/manufacturer";

const MonocyteForm = ({ initialValue, onSubmit,isLoading }) => {
  const formik = useFormik({
    initialValues: {
      monocyte_depleted_cells: initialValue || "",
    },
    validationSchema: Yup.object({
      monocyte_depleted_cells: Yup.number()
        .required("Required")
        .min(0, "Must be positive")
        .test(
          "max-decimals",
          "At most 2 decimal places are allowed",
          (value) => {
            if (value === undefined || value === null || value === "") return true;
            const str = String(value);
            const parts = str.split('.');
            return parts.length <= 1 || parts[1].length <= 2;
          }
        ),
    }),
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikControl
        formik={formik}
        label="Added Monocyte Depleted Cells"
        type="number"
        name="monocyte_depleted_cells"
        placeholder="Enter Added Monocyte Depleted Cells"
        extraContent="x10⁶ Cells"
      />

      <LoadingButton fullWidth type="submit" variant="contained" sx={{ mt: 2 }}  loading={isLoading}       
        disabled={isLoading}   >
        Submit
      </LoadingButton>
    </form>
  );
};
const CryopeserveView = ({ patientData, patientInfo, patientMedicalInfo, bagCount, formProps, getTimeLine }) => {
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();
  const bagDynamic = useSelector(selectDynamicBags)
  const [reprintData, setReprintData] = useState(null); // Separate state for reprint
  const [reprintModalOpen, setReprintModalOpen] = useState(false);
  const [carTFormExpanded, setCarTFormExpanded] = useState(true);
  const [open, setOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [monocyteLoading, setMonocyteLoading] = useState(false);

  const bloodInfo = [{
    label: 'Total CD3+ Count',
    value: `${currentCycle?.total_blood || 0} ${' x10⁶ Cells'}`
  },
  {
    label: 'Added Monocyte Depleted Cells',
    value: `${currentCycle?.monocyte_depleted_cells || 0} x10⁶ Cells`,
    editable: true
  },
  {
    label: 'Used CD3+ Count',
    value: `${currentCycle?.used_blood || 0} ${' x10⁶ Cells'}`
  },
  {
    label: 'Remaining CD3+ Count',
    value: `${currentCycle?.remaining_blood || 0} ${' x10⁶ Cells'}`,
  }]

  const handleReprint = async (index) => {
    const selectedBag = bagDynamic?.[index];

    const freshReprintData = {
      //Please remove the currentCycle data from below when the backend is ready with batch_no in the response of cycle api
      printPatientInfo: {
        ...patientData, batch_no:
          selectedBag?.bag_usage?.manufacturing_stage?.batch_no ||
          selectedBag?.batch_no ||
          selectedBag?.batch_number

      },

      patientMedicalInfo,
      patientInfo,
      bagCount: bagDynamic?.length,
      bagData: selectedBag,
      bagIndex: index,
      apheresisDate: currentCycle?.data?.find(
        (it) => it?.slug == "apheresis"
      )?.completed_date,
      cryo: true,

    };

    setReprintData(freshReprintData);
    setReprintModalOpen(true);
  };

  const handleEditMonocyte = () => {
    setDialogTitle("Monocyte Depleted Cells");
    setOpen(true);
  };

  return <div>
    <Accordion
      className={` w-100  !rounded-lg ${carTFormExpanded ? " pt-3" : " "}`}
      sx={{
        borderLeft: `4px solid ${bagDynamic?.length < 1
          ? "#FB9D2C"
          : "#00B278"
          }`,
      }}
      expanded={carTFormExpanded} // <-- make it controlled
      onChange={() => setCarTFormExpanded((prev) => !prev)} // <-- toggle manually
    >
      <AccordionSummary
        expandIcon={
          <div className="d-flex gap-3 align-items-center">
            <DownIcon />
          </div>
        }
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography className="flex flex-col gap-2 ">
          <span className="font-bold text-[0.9rem]">Cryopreserve Of LSM</span>
          <p className="flex gap-2">
            {bagDynamic?.length < 1 ? (
              <span className="flex gap-3" style={{ color: "#FB9D2C" }}>
                <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                {"In-Progress"}
              </span>
            ) : (
              <span className="flex gap-3" style={{ color: "#00B278" }}>
                <CheckGreen Filled="#00B278" />
                {"Completed"}
              </span>
            )}{" "}

          </p>
        </Typography>

      </AccordionSummary>
      <BsModal
        open={open}
        fullWidth
        maxWidth="md"
        onClose={() => setOpen(false)}
        title={dialogTitle}
      >
        <MonocyteForm
          initialValue={currentCycle?.monocyte_depleted_cells}
          isLoading={monocyteLoading}
          onSubmit={async (values) => {
            try {
              setMonocyteLoading(true);
              const payload = {
                feasibility_assessment_id:
                  currentCycle?.feasibility_assessments_id,
                monocyte_depleted_cells: Number(values.monocyte_depleted_cells) || 0,
              };

              const res = await dispatch(updateMonocyte(payload)).unwrap();

              if (res?.status === 200) {
                setOpen(false);
                getTimeLine(formProps?.subject_id);
              }
            } catch (err) {
              console.error("Monocyte update failed:", err);
            }
            finally {
              setMonocyteLoading(false); 
            }
          }}
        />
      </BsModal>
      <AccordionDetails>
        <Divider />
        {<>
          <Grid className="mb-3 mt-3 relative flex gap-3">
            {bloodInfo?.map((blood, index) => (
              <p
                key={'_key_' + index}
                className="bg-[#E8EFFC] text-[#1958EB] font-normal px-3 py-2 rounded-md w-full flex justify-between items-center"
              >
                <span>
                  {blood?.label}: <span className="font-bold">{blood?.value}</span>
                </span>
                {blood?.editable && (
                  <IconButton size="small" onClick={handleEditMonocyte}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
              </p>
            ))}
          </Grid>
          <hr /></>}

        <CryoLsmFormDialog showLsm={false} id={patientData?.id} formProps={formProps} getTimeLine={getTimeLine} onReprint={handleReprint} />

        <ReprintComponent
          open={reprintModalOpen}
          onClose={() => {
            setReprintModalOpen(false);
          }}
          printData={reprintData}
          patientInfo={patientInfo}
          bagCount={bagCount}
        />

      </AccordionDetails>
    </Accordion>
  </div >
}
export default CryopeserveView;